import { classes, stylesheet } from 'typestyle'
import { useNavigate } from 'react-router-dom'

import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* Common ======================================================================================= */
import useFetch from '../../../hooks/use-fetch'
import useBoolean from '../../../hooks/use-boolean'
import useLocal from '../../../hooks/use-local'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Line } from '../../../components/line'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text/text.component'
import { Notification } from '../../../components/notification'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../../components/style-class/style-class.utils'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { p12 } from '../../../styles/styleset/padding/p12'

Modal.add('Request', (props: any) => {
  const { to, label, destination, onConfirm } = props
  const [request, $request] = useFetch()
  const [confirming, $confirming] = useBoolean(false)
  const history = useNavigate()
  const [local] = useLocal()

  return (
    <Box onClick={props.handleContentClick} rounded minWidth={300} row>
      {label && (
        <>
          <Box className={classes(p12)} baseline="none">
            <Text size="md">{label}</Text>
          </Box>
          <Line />
        </>
      )}
      <Box className={classes(p12, STYLES.container)} baseline="none" spaceBetween fullWidth>
        <Box />
        <Box baseline="none" spaceBetween>
          <Box />
          <Box column>
            <Button
              className={mr8}
              onClick={Modal.pop}
              label={GLOBAL_CONTENTS.close[local]}
              baseline="background"
              size="md"
              square
            />
            <Button
              disabled={confirming}
              onClick={() => {
                try {
                  $confirming.set(true)
                  let requestCB: any = $request.get

                  if (to.method) {
                    requestCB = ($request as any)[to.method]
                  }

                  requestCB({
                    url: to.url,
                  }).then(() => {
                    if (onConfirm) {
                      onConfirm()
                    }
                    Modal.pop()

                    if (destination) {
                      history(destination)
                    }
                  })
                } catch (err) {
                  Notification.push({
                    baseline: 'error',
                    label: 'An error occured during the last action.',
                  })
                  console.error(err)
                } finally {
                  $confirming.set(false)
                }
              }}
              label={
                confirming ? GLOBAL_CONTENTS.confirming[local] : GLOBAL_CONTENTS.confirm[local]
              }
              baseline="primary"
              size="md"
              type="button"
              square
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
})

const STYLES = stylesheet({
  container: {
    maxHeight: 420,
    overflow: 'auto',
    ...createMediaQuery['sm']({
      maxHeight: 360,
    }),
  },
})
